const breakpoints = {
  sm: "415px",
  lg: "1000px",
  xl: "1440px",
  "2xl": "1920px",
  // these breakpoint are needed just to make others work
  "3xl": "3000px",
};

export default breakpoints;
